/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateEarnerMode} from '../api'

export const useMutationUpdateEarnerMode = createReactQueryMutationHook('updateEarnerMode', updateEarnerMode)
